import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useT } from "@/lib/i18n";

const KEY = "mo_cookie_consent";
export const openCookiePrefs = () => window.dispatchEvent(new Event("mo-cookie-prefs"));

export function CookieBanner() {
  const { t } = useT();
  const [open, setOpen] = useState(() => !localStorage.getItem(KEY));
  useEffect(() => { const h = () => setOpen(true); window.addEventListener("mo-cookie-prefs", h); return () => window.removeEventListener("mo-cookie-prefs", h); }, []);
  if (!open) return null;
  const save = (analytics) => { localStorage.setItem(KEY, JSON.stringify({ necessary: true, analytics, at: new Date().toISOString() })); setOpen(false); };
  return (
    <div data-testid="cookie-banner" role="dialog" aria-live="polite" className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-3xl rounded-3xl border border-slate-200 bg-white/95 p-5 shadow-2xl backdrop-blur sm:inset-x-6 sm:p-6">
      <div className="flex items-start gap-3">
        <span className="rounded-2xl bg-[#5aa469]/15 p-2.5 text-[#4a8a56]"><Cookie size={22} /></span>
        <div className="min-w-0 flex-1">
          <p className="font-heading font-extrabold text-slate-900">{t("cookie_title")}</p>
          <p className="mt-1 text-sm text-slate-600">{t("cookie_desc")} <Link to="/legal/cookie" data-testid="cookie-policy-link" className="font-semibold text-[#4a8a56] underline">{t("cookie_policy")}</Link> · <Link to="/legal/privacy" className="font-semibold text-[#4a8a56] underline">{t("privacy_policy")}</Link></p>
        </div>
      </div>
      <div className="mt-4 flex flex-wrap justify-end gap-2">
        <button data-testid="cookie-reject-btn" onClick={() => save(false)} className="rounded-full border border-slate-200 px-5 py-2 text-sm font-semibold text-slate-700 hover:border-slate-400">{t("cookie_reject")}</button>
        <button data-testid="cookie-accept-btn" onClick={() => save(true)} className="rounded-full bg-[#5aa469] px-5 py-2 text-sm font-semibold text-white hover:bg-[#4a8a56]">{t("cookie_accept")}</button>
      </div>
    </div>
  );
}
